/**
 * @generated SignedSource<<9f25b824139f8facb5a2d3be79eac131>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type unlockSongInput = {
  clientMutationId?: string | null;
  songId: string;
};
export type UnlockSongMutation$variables = {
  input: unlockSongInput;
};
export type UnlockSongMutation$data = {
  readonly unlockSong: {
    readonly errors: ReadonlyArray<{
      readonly __typename: "AuthError";
      readonly message: string;
    }>;
    readonly song: {
      readonly editLock: {
        readonly isLocked: boolean;
        readonly lockedBy: string;
        readonly lockedByEmail: string;
        readonly lockedUntil: string;
      } | null;
      readonly id: string;
      readonly isLockedByUser: boolean;
    } | null;
  } | null;
};
export type UnlockSongMutation = {
  response: UnlockSongMutation$data;
  variables: UnlockSongMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "unlockSongPayload",
    "kind": "LinkedField",
    "name": "unlockSong",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Song",
        "kind": "LinkedField",
        "name": "song",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "editLock",
            "kind": "LinkedField",
            "name": "editLock",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isLocked",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedByEmail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedUntil",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isLockedByUser",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnlockSongMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnlockSongMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "43fbcfe78bf10890fd7ac06e76a08036",
    "id": null,
    "metadata": {},
    "name": "UnlockSongMutation",
    "operationKind": "mutation",
    "text": "mutation UnlockSongMutation(\n  $input: unlockSongInput!\n) {\n  unlockSong(input: $input) {\n    song {\n      id\n      editLock {\n        isLocked\n        lockedBy\n        lockedByEmail\n        lockedUntil\n      }\n      isLockedByUser\n    }\n    errors {\n      __typename\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "82d7d551dff4e3dc6712b29be0411a1b";

export default node;
